import { MdEmail } from 'react-icons/md';
import { BsCalendar3, BsFileText } from 'react-icons/bs';
import toast from 'react-hot-toast';
import { AboutContainer, CTAButton, CTAButtonsContainer } from './About.styled';

type Props = {
    id: string;
};

export const About = ({ id }: Props) => {
    const handleCopyEmail = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        navigator.clipboard.writeText('eliyahou.pro@gmail.com');
        toast.success('Email copied to clipboard! 📋', {
            duration: 3000,
            style: {
                background: 'var(--primary-color)',
                color: 'var(--card-background)',
                fontWeight: '500',
            },
        });
    };

    return (
        <AboutContainer id={id}>
            <div>
                <h2>Let's Build Together</h2>
            </div>
            <p>
                Working with startups and companies to ship AI products. Got a
                project? Let's talk.
            </p>

            <CTAButtonsContainer>
                <CTAButton
                    href="https://calendly.com/eliyahou-pro/20min"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="secondary"
                >
                    <BsCalendar3 size={20} /> Free 20-min Call
                </CTAButton>
                <CTAButton
                    href="#"
                    onClick={handleCopyEmail}
                    variant="secondary"
                >
                    <MdEmail size={20} /> Email Me
                </CTAButton>
                <CTAButton
                    href="/Eliyahou_Gabbay_Resume_Solution_Builder.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="secondary"
                >
                    <BsFileText size={20} /> My Resume
                </CTAButton>
            </CTAButtonsContainer>
        </AboutContainer>
    );
};
